<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M230.437 121.665L192.504 61.0829L163.467 79.2653C154.885 76.7053 145.617 76.5709 136.453 79.2205C133.566 80.0589 131.48 83.3549 130.865 83.5597C125.88 85.2173 130.955 92.1613 136.843 98.3373L136.824 98.5741L120.933 110.779L143.806 117.172L164.741 150.612C166.373 153.217 168.971 154.83 171.774 155.304L162.84 178.44C177.182 172.603 186.814 165.39 192.427 156.916C195.397 152.436 197.496 147.08 198.776 141.48L230.424 121.665H230.437Z"
      class="fill-brand-100"
    />
    <path
      d="M198.597 141.71L129.393 98.1837C137.214 94.3821 143.717 90.1645 139.518 88.0909C138.955 87.8157 133.253 84.0397 125.784 80.8653C114.648 76.1293 102.904 75.2973 92.1838 78.4141L51.1342 52.5901L12.9006 113.377L58.0078 141.748C58.539 143.752 59.2238 145.665 60.0814 147.457C64.363 156.372 71.9406 165.844 85.3102 174.158L85.2654 173.78L134.622 204.827C140.472 208.507 148.197 206.747 151.87 200.897C152.421 200.02 152.837 199.105 153.144 198.164L160.261 202.638C166.443 206.529 174.603 204.667 178.494 198.484L178.558 198.382C180.696 194.99 181.086 190.996 179.992 187.444C185.496 188.98 191.582 186.824 194.782 181.736L194.801 181.704C197.969 176.673 197.336 170.331 193.669 166.036C197.253 165.428 200.581 163.374 202.667 160.052L202.731 159.95C206.622 153.768 204.76 145.601 198.577 141.716L198.597 141.71Z"
      class="fill-brand-300"
    />
    <path
      d="M88.355 70.3069L44.5063 140.018L7.93332 117.014C4.61245 114.925 3.61355 110.539 5.70239 107.218L41.9862 49.5333C44.0751 46.2124 48.4611 45.2135 51.782 47.3024L88.355 70.3069Z"
      class="fill-secondary-500"
    />
    <path
      d="M90.6217 93.3406C83.7141 95.4696 79.8402 102.795 81.9693 109.703C84.0983 116.611 91.424 120.484 98.3316 118.355L144.435 104.146C151.342 102.017 155.216 94.6911 153.087 87.7834C150.958 80.8758 143.632 77.002 136.725 79.131L90.6217 93.3406Z"
      class="fill-brand-100"
    />
    <path
      d="M102.795 96.2701L101.221 93.0957C100.798 92.1293 100.344 91.2333 99.8895 90.4845L90.6287 93.3389C85.4319 94.9389 81.9375 99.5405 81.4575 104.66C83.6975 105.608 87.2495 106.363 89.5343 105.908C95.3071 104.75 101.067 101.64 101.067 101.64C103.051 100.936 103.55 98.3949 102.802 96.2701H102.795Z"
      class="fill-accent-300"
    />
    <path
      d="M138.808 193.339C136.107 187.144 128.888 184.308 122.693 187.009L120.837 187.822C120.69 186.58 120.363 185.339 119.838 184.136C116.958 177.524 109.259 174.504 102.648 177.39L101.182 178.03C101.528 175.688 101.259 173.23 100.248 170.9C97.3679 164.289 89.6687 161.268 83.0575 164.155L81.7519 164.724C82.0975 162.382 81.8287 159.924 80.8175 157.595C77.9375 150.984 70.2383 147.963 63.6271 150.849L58.4751 153.096C51.8639 155.976 48.8431 163.675 51.7295 170.286C54.6095 176.897 62.3087 179.918 68.9199 177.032L70.2255 176.462C69.8799 178.804 70.1487 181.262 71.1599 183.592C74.0399 190.203 81.7391 193.224 88.3503 190.337L89.8159 189.697C89.4639 192.04 89.7391 194.497 90.7503 196.827C93.6303 203.438 101.33 206.459 107.941 203.572L110.693 202.369C110.853 203.336 111.122 204.302 111.531 205.236C114.232 211.432 121.451 214.267 127.646 211.566L132.478 209.46C138.674 206.76 141.509 199.54 138.808 193.345V193.339Z"
      class="fill-brand-100"
    />
    <path
      d="M214.077 49.534L250.361 107.219C252.45 110.54 251.451 114.926 248.13 117.014L211.557 140.019L167.712 70.3131L204.285 47.3085C207.606 45.2197 211.992 46.2186 214.081 49.5395L214.077 49.534Z"
      class="fill-brand-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Trust'
  }
</script>
